import { NgModule } from '@angular/core';
import { MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({
  imports: [MatCheckboxModule],
  exports: [MatCheckboxModule]
})
export class TiimeCheckboxModule {}
